function uniqueUserName($q, server){
    return function checkUserNameUniqueness(modelValue, viewValue, scope){
      var value = modelValue || viewValue
      var model = scope.model
  
      return server.existUserName(value, model.Id)
        .then(function(result){
          if(result){
            return $q.reject('Username is not unique')
          }
          else{
            return true
          }
        })
        .catch(function(){
          return $q.reject('Something happened')
        })
    }
  }
  
  export default uniqueUserName
  